import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";

import {
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  STATE_IDENTIFIER,
} from "./constants";

const {
  OFFICES,
  SELECTED_OFFICE,
  SHOW_ADVANCED_FILTER,
  SELECTED_USERS,
  SELECTED_ENTITLEMENTS,
  IS_POSSIBLE_TO_CONTINUE,
  LOADER_LIST_IDENTIFIER,
  LIST_ENTITLEMENTS,
  TOTAL_ENTITLEMENTS,
  ADDED_ENTITLEMENTS,
  DELETED_ENTITLEMENTS,
  MODIFIED_ENTITLEMENTS,
  PREV_ENTITLEMENTS,
  CHAIN_ENTITLEMENTS,
  CALL_STATE,
  STEP_ONE,
  STEP_TWO,
  USERS_LIST,
  SELECTED_CATALOG,
  START_END_DATE,
  SEGREGATIONS,
  UPDATED_SEGREGATION,
  ENRICHMENTS,
} = STATE_IDENTIFIER;

const emptyState = {
  [SEGREGATIONS]: {
    [LOADER_IDENTIFIER]: false,
    [LIST_IDENTIFIER]: [],
    [ENRICHMENTS]: [],
    [CALL_STATE]: IResponseState.PENDING,
    [UPDATED_SEGREGATION]: null,
  },
  [STEP_ONE]: {
    [LIST_IDENTIFIER]: [],
    [LOADER_IDENTIFIER]: false,
    [CALL_STATE]: IResponseState.PENDING,
  },
  [STEP_TWO]: {
    [SELECTED_CATALOG]: [],
    [USERS_LIST]: [],
    [LOADER_IDENTIFIER]: false,
    [CALL_STATE]: IResponseState.PENDING,
  },
  [OFFICES]: null,
  [SELECTED_OFFICE]: "",
  [SHOW_ADVANCED_FILTER]: false,
  [SELECTED_USERS]: [],
  [SELECTED_ENTITLEMENTS]: [],
  [IS_POSSIBLE_TO_CONTINUE]: false,
  [LOADER_LIST_IDENTIFIER]: false,
  [LIST_ENTITLEMENTS]: null,
  [TOTAL_ENTITLEMENTS]: [],
  [ADDED_ENTITLEMENTS]: [],
  [DELETED_ENTITLEMENTS]: [],
  [MODIFIED_ENTITLEMENTS]: [],
  [PREV_ENTITLEMENTS]: [],
  [CHAIN_ENTITLEMENTS]: [],
  [CALL_STATE]: IResponseState.SUCCESS,
  [START_END_DATE]: [],
};
export default emptyState;
